import { Box, styled, Container } from "@mui/material";
import { UnderConstruction } from "../components";

const PageWrapper = styled(Box)(() => ({
    paddingTop: "120px", // Header height (75px) + extra spacing
    minHeight: "60vh",
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    paddingBottom: "80px",
    justifyContent: "center", // Center vertically if it's the only block
}));

export const PrivacyPolicyPage = () => {
    return (
        <Container>
            <PageWrapper>
                <UnderConstruction>
                    Мы работаем над юридическими документами. <br />
                    Актуальная версия скоро появится здесь.
                </UnderConstruction>
            </PageWrapper>
        </Container>
    );
};
